import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Config from "./Config";
import * as signalR from "@microsoft/signalr";

const SignalRContext = createContext();

// Conditionally disable console logs in production
if (Config.isProduction) {
  console.log = () => {}; // Disable console.log
  console.error = () => {}; // Disable console.error
}
export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const [error, setError] = useState(null); // Optional state to track connection errors
  const token = useSelector((state) => state.login?.LoginDetails.accessToken);

  const connectionRef = useRef(null);

  useEffect(() => {
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(Config.API_CHAT_URL_live, {
        accessTokenFactory: () => token,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect([0, 2000, 10000, 30000]) // Auto reconnect
      .configureLogging(signalR.LogLevel.Warning) // Set logging level to warning
      .build();

    setConnection(newConnection);

    // Start the connection
    newConnection
      .start()
      .then(() => {
        console.log("Connected to SignalR");
      })
      .catch((error) => {
        console.error("Connection failed: ", error);
        setError(error); // Optionally track the error
      });

    // Setup event listeners for reconnection and disconnection
    newConnection.onclose((err) => {
      console.error("Connection closed: ", err);
      setError(err);
    });

    newConnection.onreconnecting((err) => {
      console.log("Reconnecting to SignalR...", err);
    });

    newConnection.onreconnected((connectionId) => {
      console.log("Reconnected to SignalR with ID: ", connectionId);
    });

    connectionRef.current = newConnection;

    return () => {
      newConnection.stop(); // Stop connection when component unmounts
    };
  }, [token]); // Re-run effect when the token changes

  return (
    <SignalRContext.Provider value={{ connection, error }}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => {
  return useContext(SignalRContext);
};
